// Polyfill: requestIdleCallback (not supported in older Safari / iOS 15-)
if (!window.requestIdleCallback) {
  window.requestIdleCallback = function (cb, opts) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () { return Math.max(0, 50 - (Date.now() - start)); }
      });
    }, (opts && opts.timeout) ? Math.min(opts.timeout, 1) : 1);
  };
  window.cancelIdleCallback = clearTimeout;
}

document.addEventListener("DOMContentLoaded", () => {
  /**
   * 🔹 Initialize swatches
   */
  function initializeSwatches(scope = document) {
    const swatchBlocks = scope.querySelectorAll(".card-wrapper .color-swatches");
    if (!swatchBlocks.length) return;

    for (const block of swatchBlocks) {
      const btns = block.querySelectorAll(".quick-add__submit.button:not([aria-haspopup])");
      btns.forEach(btn => btn.setAttribute("aria-haspopup", "dialog"));

      // Liquid already selected variant ka color "active" karke bhejta hai
      const firstLabel = block.querySelector(".swatch-label.active") || block.querySelector(".swatch-label");
      if (!firstLabel) continue;

      const selectedColor = firstLabel.getAttribute("title");
      const wishlistButton = block.closest(".card-wrapper")?.querySelector(".wishlist_button");

      if (wishlistButton && selectedColor) {
        wishlistButton.dataset.selectedVariantValue = selectedColor;
      }

      firstLabel.classList.add("active");
      const radio = firstLabel.querySelector(".swatch-radio");
      if (radio) {
        radio.checked = true;
      }
    }
  }

  /**
   * 🕐 Wait for swatches to exist before initializing
   */
  function waitForSwatches(scope = document, retries = 10) {
    requestIdleCallback(() => {
      const swatches = scope.querySelectorAll(".card-wrapper .color-swatches .swatch-label");
      if (swatches.length) {
        initializeSwatches(scope);
      } else if (retries > 0) {
        setTimeout(() => waitForSwatches(scope, retries - 1), 100);
      }
    }, { timeout: 500 });
  }

  /**
   * 🖼️ Non-blocking variant image change
   */
  const updateVariantImage = (cardWrapper, variant) => {
    if (!variant?.variant_image?.length || !variant?.variant_image[0]) return;
    const primaryImage = variant.variant_image[0];
    const images = cardWrapper.querySelectorAll(".main-img");
    if (!images.length) return;

    const generateSrcSet = (url) => {
      const widths = [165, 360, 533, 720, 940, 1066, 1710];
      return widths.map(w => `${url}&width=${w} ${w}w`).join(", ");
    };
    const srcset = generateSrcSet(primaryImage);

    requestAnimationFrame(() => {
      images.forEach(img => {
        img.src = `${primaryImage}&width=533`;
        img.srcset = srcset;
        img.sizes = "(min-width: 768px) 533px, 100vw";
      });
    });
  };

  /**
   * 🖼️ Non-swiper card: main image ko color ki pehli image se badlo
   */
  const updateMainImage = (cardWrapper, url) => {
    const images = cardWrapper.querySelectorAll(".main-img");
    if (!images.length || !url) return;
    requestAnimationFrame(() => {
      images.forEach(img => {
        img.removeAttribute("srcset");
        img.src = url;
      });
    });
  };

  /**
   * 🔗 Card links ko selected variant par point karo
   */
  const updateCardLinks = (card, variantId) => {
    const baseUrl = card.querySelector(".color-swatches")?.dataset.productUrl;
    if (!baseUrl || !variantId) return;
    const url = `${baseUrl.split("?")[0]}?variant=${variantId}`;
    card.querySelectorAll(`a[href^="${baseUrl.split("?")[0]}"]`).forEach(a => {
      a.href = url;
    });
  };

  /**
   * 🧠 Swatch change delegation (lightweight, global)
   * "change" use kiya hai, "click" nahi — label click input par dobara
   * click fire karta hai, jisse handler 2 baar chalta.
   */
  document.addEventListener("change", (e) => {
    const radio = e.target.closest(".card-wrapper .color-swatches .swatch-radio");
    if (!radio) return;

    const label = radio.closest(".swatch-label");
    const card = label.closest(".card-wrapper");
    const variantId = radio.value;
    const color = label.getAttribute("title");
    const colorKey = radio.dataset.color;

    // Update active states + selected color text
    label.parentElement.querySelectorAll(".swatch-label").forEach(l => l.classList.toggle("active", l === label));
    const valueEl = card?.querySelector(".color-swatches__value");
    if (valueEl && color) valueEl.textContent = color;

    // Media: swiper card me alt ke hisaab se filter, warna main image swap
    const cardSwiper = card?.querySelector(".card-product-swiper");
    if (cardSwiper) {
      cardSwiperFilterByColor(cardSwiper, colorKey);
    } else if (label.dataset.image) {
      updateMainImage(card, label.dataset.image);
    }
    updateCardLinks(card, variantId);

    const form =
      card?.querySelector(".card_product_add_to_card form") ||
      card?.querySelector("form[data-type='add-to-cart-form']");
    const input = form?.querySelector("input[name='id']");
    const wishlistBtn = card?.querySelector(".wishlist_button");
    const addBtn = card?.querySelector(".quick-add__submit.button");

    if (input && variantId) input.value = variantId;
    if (wishlistBtn && variantId) {
      wishlistBtn.dataset.productVariantId = variantId;
      if (color) wishlistBtn.dataset.selectedVariantValue = color;
    }
    if (addBtn) addBtn.disabled = !variantId;

    // Change image after idle
    const jsonData = card?.querySelector("#product-variants-data")?.textContent;
    if (jsonData && variantId) {
      requestIdleCallback(() => {
        try {
          const variants = JSON.parse(jsonData);
          const variant = variants.find(v => v.id == variantId);
          updateVariantImage(card, variant);
        } catch (err) {
          console.warn("⚠️ Variant JSON parse failed:", err);
        }
      });
    }
  });

  /**
   * 🔁 Observe product grid (Infinite scroll / AJAX)
   */
  function observeInfiniteScroll() {
    const grid = document.querySelector(".product-grid");
    if (!grid) return;

    const observer = new MutationObserver((mutations) => {
      let newProducts = false;
      for (const m of mutations) {
        // Check classList only — no querySelector inside observer callbacks
        if ([...m.addedNodes].some(n =>
          n.nodeType === 1 && (
            n.classList.contains('card-wrapper') ||
            n.classList.contains('card-product-swiper') ||
            n.classList.contains('grid__item')
          )
        )) {
          newProducts = true;
          break;
        }
      }

      if (newProducts) {
        requestIdleCallback(() => {
          waitForSwatches(grid);
          initCardSwiperTouch();
        }, { timeout: 800 });
      }
    });

    observer.observe(grid, { childList: true, subtree: false });
    requestIdleCallback(() => waitForSwatches(grid), { timeout: 400 });
  }

  /**
   * 🧩 Handle Shopify dynamic section reloads
   */
  document.addEventListener("shopify:section:load", (e) => waitForSwatches(e.target));

  /**
   * 🚀 Start observers after short delay
   */
  setTimeout(() => {
    waitForSwatches(document);
    observeInfiniteScroll();
  }, 300);
});

// ============================================
// Card Product Swiper - Vanilla JS
// Infinite loop scroll + auto scroll on hover
// Layout: [clone-last | real-0 ... real-(n-1) | clone-first]
//          index 0      index 1   ...  index n   index n+1
// ============================================
var CARD_SWIPER_GAP = 5; // px, must match .card-swiper-slide margin-right

// getBoundingClientRect is sub-pixel accurate — offsetWidth rounds to an
// integer, which drifted enough on some screens to show a sliver of the
// next slide at rest.
function cardSwiperStepWidth(swiperEl) {
  return swiperEl.getBoundingClientRect().width + CARD_SWIPER_GAP;
}

function cardSwiperGoTo(swiperEl, index, skipTransition) {
  var track = swiperEl.querySelector('.card-swiper-track');
  var total = swiperEl._total;
  if (!track || !total) return;

  // Cancel any pending loop-jump listener
  if (swiperEl._loopEndListener) {
    track.removeEventListener('transitionend', swiperEl._loopEndListener);
    swiperEl._loopEndListener = null;
  }

  // Clamp to the clone range (0 = clone-last ... total+1 = clone-first).
  // Without this, a next/prev call that lands outside it would animate
  // the track into empty space past the last slide element — blank.
  if (index < 0) index = 0;
  if (index > total + 1) index = total + 1;

  var step = cardSwiperStepWidth(swiperEl);

  if (skipTransition) {
    swiperEl._current = index;

    track.style.transition = 'none';
    track.style.transform =
      'translate3d(-' + (index * step) + 'px,0,0)';

    // force browser repaint
    void track.offsetHeight;

    // restore transition
    track.style.transition =
      'transform .45s cubic-bezier(.22,.61,.36,1)';

    return;
  }

  swiperEl._current = index;
  track.style.transform =
    'translate3d(-' + (index * step) + 'px,0,0)';

  // Map loop index → real index for the progress bar
  var realIndex = index - 1;
  if (realIndex < 0) realIndex = total - 1;
  if (realIndex >= total) realIndex = 0;

  var card = swiperEl.closest('.card-wrapper') || swiperEl.closest('.card__inner') || swiperEl.parentElement;
  var dotsBar = card && card.querySelector('.card-swiper-dots');
  if (dotsBar && total > 1) {
    dotsBar.style.setProperty('--swiper-thumb-w', (1 / total * 100).toFixed(2) + '%');
    dotsBar.style.setProperty('--swiper-thumb-x', (realIndex / total * 100).toFixed(2) + '%');
  }

  // After the slide transition: if we landed on a clone, silently jump to the real slide
  var onEnd = function () {
    track.removeEventListener('transitionend', onEnd);
    swiperEl._loopEndListener = null;
    if (swiperEl._current === 0) {
      cardSwiperGoTo(swiperEl, total, true);       // was clone-last  → jump to real last
    } else if (swiperEl._current === total + 1) {
      cardSwiperGoTo(swiperEl, 1, true);            // was clone-first → jump to real first
    }
  };
  swiperEl._loopEndListener = onEnd;
  track.addEventListener('transitionend', onEnd, { once: true });
}

// Steps one slide forward/back. If a fast repeat click arrives before the
// previous step's silent clone→real correction has landed (_current still
// sitting on a clone), snap it back to the real slide instantly first —
// so every step always starts from a valid real index and the target of
// +/-1 from it can never fall outside the clone range. That's what removes
// both the blank-on-overshoot bug and the "stuck at the boundary" bug,
// without needing to lock out rapid clicking.
function cardSwiperStep(swiperEl, dir) {
  if (!swiperEl || !swiperEl._total) return;
  var total = swiperEl._total;
  var cur = swiperEl._current || 1;
  if (cur === 0) cur = total;
  else if (cur === total + 1) cur = 1;
  if (cur !== swiperEl._current) {
    cardSwiperGoTo(swiperEl, cur, true);
  }
  cardSwiperGoTo(swiperEl, cur + dir);
}

function cardSwiperPrev(btn) {
  cardSwiperStep(btn.closest('.card-product-swiper'), -1);
}

function cardSwiperNext(btn) {
  cardSwiperStep(btn.closest('.card-product-swiper'), 1);
}

// ── (Re)build the loop from the currently visible slides ──
// Hidden slides ([hidden] = dusre color ki images) skip hote hain, isliye
// color badalne par yahi function dobara chala ke loop naye set se ban jaata hai.
// Media ka order wahi rehta hai jo admin me hai (DOM order touch nahi hota).
function cardSwiperBuild(swiper) {
  var track = swiper.querySelector('.card-swiper-track');
  if (!track) return;

  if (swiper._loopEndListener) {
    track.removeEventListener('transitionend', swiper._loopEndListener);
    swiper._loopEndListener = null;
  }

  // Purane clones hatao
  track.querySelectorAll('[data-swiper-clone]').forEach(function (c) { c.remove(); });

  var slides = Array.from(track.querySelectorAll('.card-swiper-slide:not([hidden])'));
  var total = slides.length;
  swiper._total = total;

  var card = swiper.closest('.card-wrapper') || swiper.closest('.card__inner') || swiper.parentElement;
  var dotsBar = card && card.querySelector('.card-swiper-dots');
  var prevBtn = swiper.querySelector('.card-swiper-prev');
  var nextBtn = swiper.querySelector('.card-swiper-next');

  if (total <= 1) {
    // Single image: no loop, no drag
    swiper._current = 0;
    track.style.transition = 'none';
    track.style.transform = 'translate3d(0,0,0)';
    if (dotsBar) dotsBar.hidden = true;
    if (prevBtn) prevBtn.classList.add('is-hidden');
    if (nextBtn) nextBtn.classList.add('is-hidden');
    return;
  }

  // ── Build infinite-loop clones ──
  var firstClone = slides[0].cloneNode(true);
  var lastClone = slides[total - 1].cloneNode(true);
  [firstClone, lastClone].forEach(function (c) {
    c.setAttribute('data-swiper-clone', '');
    c.setAttribute('aria-hidden', 'true');
  });
  track.appendChild(firstClone);                   // index total+1
  track.insertBefore(lastClone, track.firstChild); // index 0

  // Start at real index 1 (no animation)
  swiper._current = 1;
  track.style.transition = 'none';
  track.style.transform = 'translate3d(-' + cardSwiperStepWidth(swiper) + 'px,0,0)';
  void track.offsetWidth;
  track.style.transition =
    'transform .45s cubic-bezier(.22,.61,.36,1)';

  // Init progress bar
  if (dotsBar) {
    dotsBar.hidden = false;
    dotsBar.style.setProperty('--swiper-thumb-w', (1 / total * 100).toFixed(2) + '%');
    dotsBar.style.setProperty('--swiper-thumb-x', '0%');
  }

  // Both arrows always visible in loop mode
  if (prevBtn) prevBtn.classList.remove('is-hidden');
  if (nextBtn) nextBtn.classList.remove('is-hidden');
}

// ── Color swatch → sirf us color ki images (alt match) + blank-alt images ──
// Agar us color ki ek bhi image nahi mili, to sab images dikhao (card khali na ho).
function cardSwiperFilterByColor(swiper, color) {
  var track = swiper.querySelector('.card-swiper-track');
  if (!track) return;

  var key = (color || '').trim().toLowerCase();
  var slides = Array.from(track.querySelectorAll('.card-swiper-slide:not([data-swiper-clone])'));
  var hasMatch = !!key && slides.some(function (s) { return s.dataset.mediaAlt === key; });

  slides.forEach(function (s) {
    var alt = s.dataset.mediaAlt || '';
    s.hidden = hasMatch && alt !== '' && alt !== key;
  });

  // Swiper abhi init nahi hua to init khud visible slides se banayega
  if (swiper.hasAttribute('data-touch-init')) cardSwiperBuild(swiper);
}

function initCardSwiperTouch() {
  document.querySelectorAll('.card-product-swiper:not([data-touch-init])').forEach(function (swiper) {
    if (swiper.closest('.similar-products-template')) return; // stays pristine for popup cloning

    var track = swiper.querySelector('.card-swiper-track');
    if (!track) return;
    swiper.setAttribute('data-touch-init', '1');

    // Loop build (clones, progress bar, arrows). Handlers niche hamesha
    // attach hote hain, taaki baad me color change par 1 → many images ho
    // to bhi drag/hover kaam kare. Har handler _total > 1 check karta hai.
    cardSwiperBuild(swiper);

    // re-snap on any size change (e.g. an outer swiper still settling its
    // own slide width right after this ran) — skip while a loop-jump is
    // pending, or this cancels it mid-flight and strands _current on the clone
    new ResizeObserver(function () {
      if (swiper._loopEndListener || !(swiper._total > 1)) return;
      cardSwiperGoTo(swiper, swiper._current, true);
    }).observe(swiper);

    var autoInterval = null;
    var mediaEl = swiper.closest('.card__media');

    // ── Hover auto-scroll (loops forever) ──
    if (mediaEl) {
      mediaEl.addEventListener('mouseenter', function () {
        clearInterval(autoInterval);
        if (!(swiper._total > 1)) return;
        autoInterval = setInterval(function () {
          cardSwiperGoTo(swiper, swiper._current + 1);
        }, 1200);
      });
      mediaEl.addEventListener('mouseleave', function () {
        clearInterval(autoInterval);
        autoInterval = null;
      });
    }

    // ── Shared drag state ──
    var startX = 0, startY = 0;
    var dragging = false, dirLocked = false, isHorizontal = false, didRealDrag = false;

    function dragStart(x, y) {
      startX = x; startY = y;
      dragging = true; dirLocked = false; isHorizontal = false; didRealDrag = false;
      clearInterval(autoInterval); autoInterval = null;
      // resolve a pending clone→real jump instead of just cancelling it,
      // or _current gets stranded on the clone and every drag after this one sticks
      if (swiper._current === 0) {
        cardSwiperGoTo(swiper, swiper._total, true);
      } else if (swiper._current === swiper._total + 1) {
        cardSwiperGoTo(swiper, 1, true);
      } else if (swiper._loopEndListener) {
        track.removeEventListener('transitionend', swiper._loopEndListener);
        swiper._loopEndListener = null;
      }
      track.style.transition = 'none';
    }

    function dragMove(x, y) {
      if (!dragging) return;
      var dx = x - startX, dy = y - startY;
      if (!dirLocked) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        isHorizontal = Math.abs(dx) >= Math.abs(dy);
        dirLocked = true;
      }
      if (!isHorizontal) return;
      didRealDrag = true;
      var base = -(swiper._current || 1) * cardSwiperStepWidth(swiper);
      track.style.transform =
        'translate3d(' + (base + dx) + 'px,0,0)';
    }

    function dragEnd(x) {
      if (!dragging) return;
      dragging = false;
      track.style.transition =
        'transform .45s cubic-bezier(.22,.61,.36,1)';
      if (!isHorizontal || !didRealDrag) { cardSwiperGoTo(swiper, swiper._current); return; }
      var diff = startX - x;
      var cur = swiper._current || 1;
      cardSwiperGoTo(swiper, Math.abs(diff) > 40 ? (diff > 0 ? cur + 1 : cur - 1) : cur);
    }

    // ── Touch ──
    swiper.addEventListener('touchstart', function (e) {
      if (!(swiper._total > 1)) return;
      dragStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    swiper.addEventListener('touchmove', function (e) {
      dragMove(e.touches[0].clientX, e.touches[0].clientY);
      if (isHorizontal && dirLocked) e.preventDefault();
    }, { passive: false });

    swiper.addEventListener('touchend', function (e) {
      dragEnd(e.changedTouches[0].clientX);
    }, { passive: true });

    // ── Mouse ──
    swiper.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || !(swiper._total > 1)) return;
      e.preventDefault();
      dragStart(e.clientX, e.clientY);

      function onMove(e) { dragMove(e.clientX, e.clientY); }
      function onUp(e) {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        dragEnd(e.clientX);
      }
      document.addEventListener('mousemove', onMove, { passive: true });
      document.addEventListener('mouseup', onUp, { once: true });
    });

    // Block card link click after a real drag
    swiper.addEventListener('click', function (e) {
      if (didRealDrag) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });
}

document.addEventListener('DOMContentLoaded', initCardSwiperTouch);
document.addEventListener('shopify:section:load', initCardSwiperTouch);
document.addEventListener('collection:updated', initCardSwiperTouch);

// Global observer — catches any dynamic content (related products, recently viewed, etc.)
(function () {
  var pending = false;
  function scheduleInit() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      initCardSwiperTouch();
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        // Only check classList — never do n.querySelector() inside MutationObserver
        // (querySelector on every added node is an O(n) deep scan and blocks the main thread)
        if (
          n.classList.contains('card-product-swiper') ||
          n.classList.contains('card-wrapper') ||
          n.classList.contains('product-grid') ||
          n.classList.contains('card__media')
        ) {
          scheduleInit();
          return;
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
}());